"use client";

import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export function SinglePayoutModal({ children }: { children: React.ReactNode }) {
  return (
    <Dialog>
      <DialogTrigger asChild>
        {children}
      </DialogTrigger>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>Send Single Payout</DialogTitle>
          <DialogDescription>
            Transfer funds directly to any bank account.
          </DialogDescription>
        </DialogHeader>
        <form className="space-y-4">
          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-2">
              <Label htmlFor="bank">Bank Name</Label>
              <select id="bank" className="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2">
                <option>Select Bank...</option>
                <option>Access Bank</option>
                <option>GTBank</option>
                <option>Zenith Bank</option>
              </select>
            </div>
            <div className="space-y-2">
              <Label htmlFor="account">Account Number</Label>
              <Input id="account" placeholder="0123456789" />
            </div>
          </div>
          <div className="space-y-2">
            <Label htmlFor="name">Beneficiary Name</Label>
            <Input id="name" placeholder="John Doe" disabled value="JOHN DOE" className="bg-muted/50" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="amount">Amount (₦)</Label>
            <Input id="amount" type="number" placeholder="0.00" />
          </div>
          <div className="bg-muted/50 p-3 rounded-lg border border-border/50 text-xs">
            <div className="flex justify-between mb-1">
              <span className="text-muted-foreground">Transfer Fee:</span>
              <span className="font-medium">₦50.00</span>
            </div>
            <div className="flex justify-between font-bold">
              <span>Total Deduction:</span>
              <span className="text-primary">₦0.00</span>
            </div>
          </div>
          <Button className="w-full">Send Payout</Button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
